export default (that) => [
  {
    text: '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: '编辑模板',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ status }) => !['Y'].includes(status),
  },
  {
    text: '删除模板',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ status }) => ['D'].includes(status),
  },
]
